import React from 'react';

const ProfilePage = () => {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold mb-4">Mon profil</h1>
      <p className="text-gray-600">Gérez vos informations, centres d’intérêt, préférences IA, etc.</p>
    </div>
  );
};

export default ProfilePage;
